import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import TripImage from 'assets/default-trip-image.png';
import Footer from 'components/Footer';

import { AFRICA_SAFARI_LIGHT_LOGOS, TANZANIA_SPECIALIST_LIGHT_LOGOS } from 'utils/constants';

import './styles.css';

export interface IAuthPage {
  children: React.ReactNode;
}

const AuthPage = ({ children }: IAuthPage) => {
  const { i18n } = useTranslation();

  const tanzaniaSpecialistLightLogo = useMemo(() => {
    return _.get(TANZANIA_SPECIALIST_LIGHT_LOGOS, i18n.language);
  }, [i18n.language]);

  const africaSafariLightLogo = useMemo(() => {
    return _.get(AFRICA_SAFARI_LIGHT_LOGOS, i18n.language);
  }, [i18n.language]);

  return (
    <div className='flex flex-col justify-center min-h-screen'>
      {/* large screens top header */}
      <div className='hidden md:flex auth-page-layout pt-9 justify-center h-[220px]'>
        <div className='flex h-[66px] gap-6'>
          <img src={tanzaniaSpecialistLightLogo} className='h-[61px] shrink-0' alt='Tanzania Specialist Logo' />
          <img src={africaSafariLightLogo} className='h-[61px] shrink-0' alt='Africa Safari Logo' />
        </div>
      </div>
      {/* end large screens top header */}
      {/* small screens top header */}
      <div className='md:hidden flex justify-center pt-[25px] auth-page-mobile-layout h-[150px]'>
        <div>
          <div className='flex h-[44px] items-center justify-center gap-6'>
            <img src={tanzaniaSpecialistLightLogo} className='h-[40px] shrink-0' alt='Tanzania Specialist Logo' />
            <img src={africaSafariLightLogo} className='h-[40px] shrink-0' alt='Africa Safari Logo' />
          </div>
        </div>
      </div>
      {/* end small screens top header */}

      <div className='self-center flex gap-[80px] flex-col p-[16px] lg:p-0 w-full lg:w-5xl max-w-[500px] lg:max-w-[1050px] lg:flex-row mt-[50px] md:mt-0'>
        <img src={TripImage} width={456} className='hidden lg:block' />
        {children}
      </div>
      <Footer className='mt-auto' />
    </div>
  );
};

export default AuthPage;
